var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightButtonBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon300_chevron_right"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_374_3303",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_374_3303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chevron_right",
    d: "M9.70977 9.00001L6.25977 5.55001L7.05013 4.75964L11.2905 9.00001L7.05013 13.2404L6.25977 12.45L9.70977 9.00001Z",
    fill: "#111111"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightButtonBlack);
export default __webpack_public_path__ + "static/media/right_button_black.5b291d836a3d7bd4e976e08cba6d3635.svg";
export { ForwardRef as ReactComponent };